import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
export default function useCheckUserFlag(flag) {
    const currentUser = useCurrentUser();
    const flags = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.flags) || [];
    return flags.includes(flag);
};
